/** ArollUploader.tsx — footage drop zone + upload queue. */
export const uploader = {
  /** Drop-zone sentence; the {browse} button renders inline right after
   *  this text, so it ends mid-sentence. */
  'uploader.dropHere': 'Drop interview footage here, or',
  /** Inline button completing the drop-zone sentence ("…, or browse"). */
  'uploader.browse': 'browse',
  /** Primary control in the ▲ROLL room: opens the file picker, then
   *  the balance confirm, then hands off to the upload tray. */
  'uploader.addFootage': 'Add footage',
  'uploader.keepOpenNote':
    'Uploads go straight from your browser and transcribe automatically. Keep this page open until each file finishes.',
  /** Encoding advice. Keep the technical terms (H.264, Mbps, kbps) and
   *  figures as-is; "conforms" is edit-suite jargon for relinking the
   *  cut to the original full-quality files. */
  'uploader.proxyTip':
    'Tip: a small proxy is all A-Roll needs. 540p H.264 at ~1 Mbps is plenty (about 450 MB per hour). Keep audio at 128 kbps or better, it drives the transcript. Your cut conforms against your originals.',
  /** Shown while file durations + the minute balance are being probed. */
  'uploader.readingLengths': 'Reading file lengths…',
  /** Per-file duration cell when the container can't be probed (e.g. MXF). */
  'uploader.lengthUnknown': 'length unknown',
  /** Per-file duration; {n} is whole minutes ("42 min"). */
  'uploader.fileMinutes_one': '{n} min',
  'uploader.fileMinutes_other': '{n} min',
  'uploader.noMinutesLeft': 'You have no footage minutes left this month.',
  /** Link label inside the no-minutes message; the sentence continues
   *  with uploader.noMinutesTail. */
  'uploader.managePlan': 'Manage your plan',
  /** Sentence tail after the Manage-your-plan link. */
  'uploader.noMinutesTail': 'to keep uploading.',
  /** Pre-upload cost summary. {minutes} is whole minutes about to be
   *  spent; {hours} is the remaining balance afterwards, like "3.1". */
  'uploader.costSummary':
    "This upload is ~{minutes} min of footage — you'll have {hours} hrs left this month.",
  /** Amber warning appended after uploader.costSummary. */
  'uploader.overBalance': 'This runs past your remaining balance.',
  /** Confirm button that starts the upload. */
  'uploader.upload': 'Upload',
  'uploader.cancel': 'Cancel',
  /** Queue row status labels (rendered in uppercase by CSS). */
  'uploader.statusQueued': 'Queued',
  'uploader.statusPaused': 'Paused',
  'uploader.statusDone': 'Done',
  'uploader.statusFailed': 'Failed',
  /** Pause/resume the in-flight transfer for one file. */
  'uploader.pause': 'Pause',
  'uploader.resume': 'Resume',
  'uploader.retry': 'Retry',
  'uploader.uploadedNote': 'Uploaded. Transcription continues in the reel below.',
  /** Fallback error when the failed upload carries no message. */
  'uploader.uploadFailed': 'Upload failed',
  /** File sizes; {n} is a pre-formatted number ("1.4", "320"). */
  'uploader.sizeGb': '{n} GB',
  'uploader.sizeMb': '{n} MB',
  'uploader.sizeKb': '{n} KB',
} as const;
